<!--  -->
<template>
  <div class="container">
    <div class="page_title">裁判员</div>
    <!-- 年份选择器 -->
    <YearSelect
      :defaultValue="newYearData"
      :yearOptions="yearOptions"
      @changeYear="changeYear"
    ></YearSelect>
    <!-- 人员数 -->
    <div class="model_box model_box_1">
      <img src="../../assets/imgs/page/3.png" alt="" />
      <div class="value">
        <span class="num">{{athIetes.cpyList}}</span>
        <span class="unit">人</span>
      </div>
    </div>
    <div class="model_box model_box_2">
      <div class="model_box_title">裁判员等级</div>
      <div class="model_box_content">
        <div class="legend_box">
          <!-- <div class="item" v-for="v in XLpieData" :key="v.name"> -->
          <div class="item">
            <div class="echart_box"><PieChart :data="athIetes.GJpieData"></PieChart></div>
            <!-- <div class="tag" :style="{ background: v.color }"></div> -->
            <div class="info">
              <span class="name">{{ athIetes.GJName }}</span>
              <span class="name">数量</span>
              <span class="value">{{ athIetes.GJNum }}</span>
            </div>
            
          <!-- </div> -->
          </div>
          <div class="item">
              <div class="echart_box"><PieChart :data="athIetes.GJJpieData"></PieChart></div>
              <!-- <div class="tag" :style="{ background: v.color }"></div> -->
              <div class="info">
                <span class="name">{{ athIetes.GJJName }}</span>
                <span class="name">数量</span>
                <span class="value">{{ athIetes.GJJNum }}</span>
              </div>
             </div>
            <div class="item">
              <div class="echart_box"><PieChart :data="athIetes.YJpieData"></PieChart></div>
              <!-- <div class="tag" :style="{ background: v.color }"></div> -->
              <div class="info">
                <span class="name">{{ athIetes.YJName }}</span>
                <span class="name">数量</span>
                <span class="value">{{ athIetes.YJNum }}</span>
              </div>
            </div>
        </div>
      </div>
    </div>
     <div class="model_box model_box_3">
      <div class="model_box_title">执裁项</div>
      <div class="model_box_content">
        <GreenLineChart :data="test1LineData"></GreenLineChart>
      </div>
    </div>

    <div class="model_box model_box_4">
      <div class="model_box_title">性别</div>
      <div class="model_box_content">
        <div class="echart_box"><PieChart :data="athIetes.XBpieData"></PieChart></div>
        <div class="legend_box">
          <div class="item">
            <img src="../../assets/imgs/page/man.png" alt="" />
            <div class="info">
              <span class="name">{{ athIetes.XBpieData[0].name }}</span>
              <span class="value">{{ athIetes.XBpieData[0].value }}</span>
            </div>
          </div>
          <div class="item">
            <img src="../../assets/imgs/page/woman.png" alt="" />
            <div class="info">
              <span class="name">{{ athIetes.XBpieData[1].name }}</span>
              <span class="value">{{ athIetes.XBpieData[1].value }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="model_box model_box_5">
      <div class="model_box_title">学历</div>
      <div class="model_box_content">
        <div class="echart_box"><PieChart :data="athIetes.XLpieData"></PieChart></div>
        <div class="legend_box">
          <div class="item" v-for="v in athIetes.XLpieData" :key="v.name">
            <div class="tag" :style="{ background: v.color }"></div>
            <div class="info">
              <span class="name">{{ v.name }}</span>
              <span class="value">{{ v.value }}</span>
            </div>
          </div>
        </div>
      </div>
      
    </div>
        <!-- <div class="model_box model_box_5">
          <div class="model_box_title">年龄</div>
          <div class="model_box_content">
            <GreenBarChart :data="NLBarData"></GreenBarChart>
          </div>
        </div> -->
      <div class="model_box model_box_5">
        <div class="model_box_title">年龄</div>
        <div class="model_box_content">
          <GreenLineChart :data="test2LineData"></GreenLineChart>
        </div>
      </div>
    
  </div>
</template>

<script>
// 绿色-柱状图
import GreenLineChart from '@/components/echarts/SingleLineChartGreen.vue'
// 绿色-柱状图
import GreenBarChart from '@/components/echarts/SingleBarChartGreen.vue'
// 蓝色-柱状图
import BlueBarChart from '@/components/echarts/SingleBarChartBlue.vue'
// 饼图
import PieChart from '@/components/echarts/PieChartWithoutLabel.vue'
// 接口数据
import { cpyBigScreen } from '@/api/dataManage'
import { Message } from 'element-ui'
export default {
  components: { GreenLineChart,GreenBarChart, BlueBarChart, PieChart },
  data() {
    return {
      showDialog: false,
      test1LineData: {
        xData: ['testtest1', 'testtest2', 'testtest3', 'testtest4'],
        yData: [100, 200, 334, 390],
        rotate: 10, // x轴文字过长溢出时配置
      },
      test2LineData: {
        xData: ['testtest1', 'testtest2', 'testtest3', 'testtest4'],
        yData: [100, 200, 334, 390],
        rotate: 10, // x轴文字过长溢出时配置
      },
      athIetes: {},
      // 年份选择器
      yearValue: '',
      yearOptions: [
        {
          value: '2026',
          label: '2026年'
        },
        {
          value: '2025',
          label: '2025年'
        },
        {
          value: '2024',
          label: '2024年'
        },
        {
          value: '2023',
          label: '2023年'
        },
        {
          value: '2022',
          label: '2022年'
        },
        {
          value: '2021',
          label: '2021年'
        },
        {
          value: '2020',
          label: '2020年'
        },
        {
          value: '2019',
          label: '2019年'
        }
      ],
      GWDJBarData: {
        // xData: [
        //   '正高级(二级)',
        //   '正高级(三级)',
        //   '正高级(四级)',
        //   '副高级(五级)',
        //   '副高级(六级)',
        //   '副高级(七级)',
        //   '中级(八级)',
        //   '中级(九级)',
        //   '中级(十级)',
        //   '初级(十一级)',
        //   '初级(十二级)',
        //   '初级(十三级)'
        // ],
        // yData: [200, 334, 390, 200, 334, 390, 330, 220, 100, 200, 334, 390],
        // rotate: 10
      },
      XLpieData: [
        // {
        //   name: '博士研究生',
        //   value: 1400,
        //   color: '#3BA0FE'
        // },
        // {
        //   name: '硕士研究生',
        //   value: 2400,
        //   color: '#FDA53D'
        // },
        // {
        //   name: '本科',
        //   value: 1400,
        //   color: '#04A463'
        // },
        // {
        //   name: '本科以下',
        //   value: 1400,
        //   color: '#FFD023'
        // }
      ],
      XWpieData: [
        // {
        //   name: '博士',
        //   value: 1400,
        //   color: '#3BA0FE'
        // },
        // {
        //   name: '硕士',
        //   value: 2400,
        //   color: '#FDA53D'
        // },
        // {
        //   name: '学士',
        //   value: 1400,
        //   color: '#04A463'
        // },
        // {
        //   name: '无',
        //   value: 1400,
        //   color: '#FFD023'
        // }
      ],
      XBpieData: [
        // {
        //   name: '男性',
        //   value: 1400,
        //   color: '#3BA0FE'
        // },
        // {
        //   name: '女性',
        //   value: 2400,
        //   color: '#FD3F7A'
        // }
      ],
      NLBarData: {
        // xdata: ['20-25', '26-30', '31-35', '35以上'],
        // ydata: [200, 334, 390, 200]
      },
      ZZMMBarData: {  
        // xData: ['中共党员', '中共预备党员', '共青团员', '群众'],
        // yData: [100, 200, 334, 390]
      },
      newYearData:'2023',
    }
  },
  computed: {},
  methods: {
    openDialog() {
      this.showDialog = true;
    },
    closeDialog() {
      this.showDialog = false;
    },
    changeYear(val) {
      this.yearValue = val
      console.log('🚀 ~ changeYear ~ val:', val);
      this.newYearData = val;
      this.researchList();
      
    },
    researchList() {
      const pageForm = {
        // page: this.page,
        // pageSize: this.pageSize,
        // taskTypeId: this.taskTypeId,
        year:this.newYearData
      };
      let pageableForm = { ...pageForm};
      cpyBigScreen(pageableForm)
        .then((res) => {
          console.log('res', res)
          if (res.code == 0) {
            this.athIetes = res.data
            // 岗位等级
            // this.ZCXBarData = res.data.ZCXBarData;
            this.test1LineData.xData = res.data.ZCXBarData.xdata;
            this.test1LineData.yData = res.data.ZCXBarData.ydata;

             this.test2LineData.xData = res.data.NLBarData.xdata;
            this.test2LineData.yData = res.data.NLBarData.ydata;
            // // 学历
            // this.XLpieData = res.data.XLpieData;
            // // 学位
            // this.XWpieData = res.data.XWpieData;
            // // 性别
            // this.XBpieData = res.data.XBpieData;
            // // 年龄
            // this.NLBarData = res.data.NLBarData;
            // // 政治面貌
            // this.ZZMMBarData = res.data.ZZMMBarData;
          } else {
            // Message(res.msg);

            Message({
              type: 'warning',
              message: res.msg,
            })
          }
        })
        .catch((error) => {
          console.log('catch', error)
        })
    },
  },
  created() {
    this.researchList()
  },
  mounted() {},
  destroyed() {}
}
</script>
<style lang="less" scoped>
// ------------------布局相关
.container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-content: space-between;
}
.model_box {
  height: calc(33.3% - 10px);
  background: #fff;
  border-radius: 5px;
  .model_box_title {
    font-size: 15px;
    height: 30px;
    line-height: 33px;
    font-weight: bold;
    padding-left: 20px;
    letter-spacing: 2px;
  }
  .model_box_content {
    height: calc(100% - 30px);
    width: 100%;
  }
}
// 人员数
.model_box_1 {
  width: calc(15% - 7px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  img {
    margin-bottom: 10px;
    width: 55px;
  }
  .value {
    font-size: 24px;
    font-weight: bold;
    .unit {
      font-size: 14px;
      font-weight: 400;
      margin-left: 2px;
    }
  }
}

.model_box_2{
  width: calc(85% - 7px);
  .model_box_content {
    display: flex;
    padding-right: 40px;
    .legend_box {
      width: 100%;
      height: 100%;
      display: flex;
      // flex-wrap: wrap;
      justify-content: flex-start;
      align-content: center;
      .item {
        width: calc(40% - 10px);
        height: calc(100% - 20px);
        background: #f8fafd;
        border-radius: 8px;
        display: flex;
        justify-content:flex-start;
        align-content: center;
        padding: 5px 0px 5px 10px;
        .echart_box {
          // background:blue;
          width: 50%;
          height: 100%;
        }
        .info {
          // background:red;
          // width:300px;
          // background:red;
          padding-top:6%;
          font-weight: 700;
          .name {
            font-size: 16px;
            // width: 75px;
          }
          .value {
            font-size: 24px;
          }
          span{
            display:block;
            width:80px;
            text-align:center;
            margin-bottom:10px;
          }
        }
      }
    }
  }
}
.model_box_3 {
  width: calc(100% - 7px);
}
.model_box_4 {
  width: calc(20% - 7px);
  .model_box_content {
    display: flex;
    // padding-right: 40px;
    .echart_box {
      width: 40%;
      height: 100%;
    }
    .legend_box {
      width: 60%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      .item {
        width: 100%;
        height: calc(50% - 20px);
        background: #f8fafd;
        border-radius: 8px;
        display: flex;
        align-items: center;
        padding-left: 20px;
        img {
          width: 30px;
          height: 30px;
          margin-right: 10px;
        }
        .info {
          font-weight: 700;
          display: flex;
          align-items: center;
          .name {
            font-size: 13px;
            width: 45px;
          }
          .value {
            font-size: 18px;
          }
        }
      }
    }
  }
}
.model_box_5{
  width: calc(40% - 7px);
  .model_box_content {
    display: flex;
    padding-right: 40px;
    .echart_box {
      width: 35%;
      height: 100%;
    }
    .legend_box {
      width: 65%;
      height: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-content: space-evenly;
      .item {
        width: calc(50% - 10px);
        height: calc(50% - 20px);
        background: #f8fafd;
        border-radius: 8px;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        padding: 5px 0px 5px 10px;
        .tag {
          width: 20px;
          height: 4px;
          border-radius: 2px;
        }
        .info {
          font-weight: 700;
          display: flex;
          align-items: center;
          .name {
            font-size: 13px;
            width: 75px;
          }
          .value {
            font-size: 18px;
          }
        }
      }
    }
  }
}




.dialog-wrapper {
  padding:20px;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
}
.model_box_8{
  width: calc(90% - 20px);
  .tit{
    display:flex;
    justify-content: space-between;
    .close{
      margin-top:5px;
      margin-right:10px;
    }
  }
}
</style>
